import { render, staticRenderFns } from "./UrlModal.vue?vue&type=template&id=2376564d&scoped=true&"
import script from "./UrlModal.vue?vue&type=script&lang=js&"
export * from "./UrlModal.vue?vue&type=script&lang=js&"
import style0 from "./UrlModal.vue?vue&type=style&index=0&id=2376564d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2376564d",
  null
  
)

export default component.exports